import clsx from "clsx";
import React from "react";
import { createUseStyles } from "react-jss";
import { revoke } from "../../services/session";
import User from "./tours/User";
import { SIDEBAR_WIDTH } from "./tours/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useWindowSize from "../../../lib/player/src/hooks/useWindowSize";

const useStyles = createUseStyles({
  topbar: {
    "background-color": "#252525",
    height: 50,
    width: "100%",
    padding: [0, 15],
    display: "flex",
    color: "white",
    "flex-direction": "row",
    "align-items": "center",
    "justify-content": "space-between",
    "box-sizing": "border-box",
    "& h1": {
      "flex-shrink": 1,
      width: SIDEBAR_WIDTH - 15,
      "@media (max-width: 700px)": {
        "font-size": 20,
      },
    },
  },
  grow: { "flex-grow": 1 },
  links: {
    display: "flex",
    height: "100%",
    "flex-shrink": 0,
  },
  button: {
    display: "flex",
    "align-items": "center",
    height: "100%",
    padding: [0, 10],
    transition: "background-color 0.2s ease",
    cursor: "pointer",

    "&:hover": {
      "background-color": "#313131",
    },

    "& svg": {
      "font-size": 18,
      "@media (min-width: 750px)": {
        "margin-right": 10,
      },
    },
  },
  disabled: {
    cursor: "not-allowed",
    color: "#aaa",
  },
});

const TopBar = ({
  links: { onTourSettings, onEmbedTour, onSaveTour, dirty, onExit, noLinks } = {
    noLinks: true,
  },
}) => {
  const classes = useStyles();
  const { width } = useWindowSize();
  const large = width >= 750;

  return (
    <div className={classes.topbar}>
      <h1>TouchTour Studio</h1>
      {!noLinks && (
        <>
          <div className={classes.button} onClick={onTourSettings}>
            <FontAwesomeIcon icon={["fal", "gear"]} fixedWidth />
            {large && " Options"}
          </div>
          <div className={classes.button} onClick={onEmbedTour}>
            <FontAwesomeIcon icon={["fal", "code"]} fixedWidth />
            {large && " Embed"}
          </div>
          <div key="grow" className={classes.grow} />
          <div
            className={clsx(classes.button, {
              [classes.disabled]: !dirty,
            })}
            onClick={onSaveTour}
          >
            <FontAwesomeIcon
              icon={["fal", dirty ? "floppy-disk" : "floppy-disk-circle-xmark"]}
              fixedWidth
            />
            {large && " Save"}
          </div>
          <div className={classes.button} onClick={onExit}>
            <FontAwesomeIcon icon={["fal", "person-running"]} fixedWidth />
            {large && " Exit"}
          </div>
        </>
      )}
      <User logout={revoke} />
    </div>
  );
};

export default TopBar;
